export default {
    checkitEnv: process.env.REACT_APP_CHECKIT_ENV,
    auth: {
        accessTokenValidity: Number(process.env.REACT_APP_ACCESS_TOKEN_MIN_VALIDITY_SECS) || 30,
        authProvider: process.env.REACT_APP_AUTH_PROVIDER || 'KEYCLOAK',
        clientId: process.env.REACT_APP_OAUTH2_CLIENT_ID,
        realm: process.env.REACT_APP_OAUTH2_REALM,
        url: process.env.REACT_APP_OAUTH2_API_URL
    },
    backend: {
        url: process.env.REACT_APP_API_URL || 'http://localhost:3000/api'
    },
    controlCentre: {
        url: process.env.REACT_APP_FRONTEND_HOME_URI
    },
    customerProfile: {
        url: process.env.REACT_APP_CUSTOMER_PROFILE_API_URL || 'http://localhost:4000'
    },
    tracking: {
        forceEnabled: process.env.REACT_APP_FORCE_ENABLED_TRACKING || 'false'
    }
};
//# sourceMappingURL=config.js.map